/* eslint-disable no-unused-expressions */
import { createGlobalStyle } from 'styled-components';

const MobileStyle = createGlobalStyle`

  .popup-content {
      margin: 75px auto !important;
      width: 90% !important;
      overflow: hidden;
  }

  .htmlWrpFiles {

    p {
      font-size: 2rem !important;
    }

    ul li, ol li {
      font-size: 2rem !important;
    }

    h3 {
      font-size: 2.5rem !important;
    }
  }

`;

export default MobileStyle;
